'use strict';

import BaseService from './base.service';

class SalesmenService extends BaseService {
  /* @ngInject */
  constructor(Salesman, SegaUser) {
    super(Salesman, SegaUser);
    Object.assign(this, {
      Salesman
    });
  }
}

export default SalesmenService;
